import { Col, Row } from "react-bootstrap";
import Title from "src/components/Title";

const NotFoundSite = () => {
  return (
    <Row>
      <Col>
        <Title>Seite nicht gefunden</Title>
      </Col>
    </Row>
  );
};

export default NotFoundSite;
